"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanCell = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Check_1 = __importDefault(require("@material-ui/icons/Check"));
const Remove_1 = __importDefault(require("@material-ui/icons/Remove"));
const table_field_styles_1 = require("../table-field-styles");
exports.BooleanCell = react_1.memo(function BooleanCell({ value, }) {
    const classes = table_field_styles_1.useStyles();
    return (react_1.default.createElement(Typography_1.default, { classes: { root: clsx_1.default(classes.tableCell, classes.tableCellFlex) } }, value ? react_1.default.createElement(Check_1.default, null) : react_1.default.createElement(Remove_1.default, null)));
});
//# sourceMappingURL=boolean-cell.js.map